var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.519,
    height: 26.501,
    viewBox: "0 0 26.519 26.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trend",
    transform: "translate(-58 -59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M78.544,70.185l8.6-8.552v3.546h1.537V59H82.452v1.548h3.584l-7.528,7.476-6.252-6.257L62.49,71.683l1.037,1.036,8.805-8.752Z",
    transform: "translate(-4.179 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M58,209.383h1.551v-7.861h4.708v7.845h1.549v-12.5h4.665v12.5h1.558V199.97h4.656v9.4h1.558V193.76h4.717v15.616h1.558v1.56H58Z",
    transform: "translate(0 -125.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M78.544,70.185l-6.212-6.218-8.805,8.752L62.49,71.683l9.765-9.916,6.252,6.257,7.528-7.477H82.452V59h6.233v6.178H87.148V61.633Z",
    transform: "translate(-4.179 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/trend.3edf1cc337d47176550019ebcafc0300.svg";
export { ForwardRef as ReactComponent };